<div class="app_ui_splash_logo">
  <img src="/assets/images/splash_logo.png">
</div>
